import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { ConciergeErrorResponse } from 'src/api/concierge';
import { BookingsEndpoints } from 'src/features/bookings';
import { getInspections } from 'src/features/bookings/api';

import { HousekeepingInspection } from '../api';

type QueryConfig = UseQueryOptions<
    HousekeepingInspection | null,
    AxiosError<ConciergeErrorResponse>
>;

export const useGetInspections = (academic_year?: string, config: QueryConfig = {}) =>
    useQuery<HousekeepingInspection | null, AxiosError<ConciergeErrorResponse>>({
        enabled: Boolean(academic_year),
        queryKey: [BookingsEndpoints.getInspections, academic_year],
        queryFn: async (): Promise<HousekeepingInspection | null> =>
            academic_year ? getInspections(academic_year) : null,
        ...config,
    });
